// @ts-check

/**
 * @file Defines an Expo route wrapper.
 */
import _ from "gettext-universal/build/src/translate.js"
import useLocale from "gettext-universal/build/src/use-locale-expo.js"
import {memo} from "react"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import InvoiceLineEditScreen from "../../src/screens/invoice-lines/edit-screen"
import ScreenTitle from "../../src/components/screen-title"

/** @import {NamedExoticComponent, ReactNode} from "react" */

/** @typedef {{[key: string]: unknown}} InvoiceLineNewRouteProps */

/** @typedef {Record<string, never>} InvoiceLineNewRouteState */

/**
 * Renders an Expo route screen.
 * @augments {ShapeComponent<InvoiceLineNewRouteProps, InvoiceLineNewRouteState>}
 */
class InvoiceLineNewRoute extends ShapeComponent {
  /** Initializes route hooks. */
  setup() {
    useLocale()
  }

  /**
   * Renders route content.
   * @returns {ReactNode} Rendered route content.
   */
  render() {
    return (
      <>
        <ScreenTitle>{_("New invoice line")}</ScreenTitle>
        <InvoiceLineEditScreen />
      </>
    )
  }
}

/** @type {NamedExoticComponent<InvoiceLineNewRouteProps>} */
const InvoiceLineNewRouteComponent = memo(shapeComponent(InvoiceLineNewRoute))

export default InvoiceLineNewRouteComponent
